module.exports = __webpack_public_path__ + "static/img/bgImage4-content.f032879.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technicalAdvantages/bgImage4-content.png
// module id = 85Un
// module chunks = 0